import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import PlayArrowRoundedIcon from '@material-ui/icons/PlayArrowRounded';
import PauseRoundedIcon from '@material-ui/icons/PauseRounded';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import FlagstoneTheme from '../../Config/flagstoneTheme';
import { productionOrderStates as state } from '../../Config/productionOrderStates'
import Timer from '../Shared/Timer';
import { dataService } from '../../Services/data.service';
import { toast } from 'react-toastify';
import { machineScissorZone } from '../../Config/constants';

export default function OrderState(props) {
    const classes = useStyles();
    const { t } = useTranslation();

    let history = useHistory();
    let canSwitchRawMaterial = false;

    let stateIcon = <React.Fragment></React.Fragment>;
    switch (props.productionOrder.productionOrderStatus) {
        case state.RUNNING:
            stateIcon = <PlayArrowRoundedIcon className={classes.play}></PlayArrowRoundedIcon>;
            break;
        case state.PAUSED:
            stateIcon = <PauseRoundedIcon className={classes.pause} ></PauseRoundedIcon>;
            break;
        case state.STOPPED:
            stateIcon = <div className={classes.stop}></div>;
            break;
        case state.DONE:
            stateIcon = <img className={classes.done} alt="done" src={process.env.PUBLIC_URL + '/img/done.svg'}></img>
            break;
        case state.PLANNED:
            stateIcon = <img className={classes.planned} alt="planned" src={process.env.PUBLIC_URL + '/img/planned.svg'}></img>
            canSwitchRawMaterial = true;
            break;
        default:
    }

    const navigateToOrderDetail = () => {

        if (props.productionOrder.bowMetaData) {
            let metaData = JSON.parse(props.productionOrder.bowMetaData).find(x => x.MetaDataType === 1).MetaData[0]
            if (metaData.UsedZones.length > 0) {

                dataService.getMachinesByMachineType(machineScissorZone).then(zones => {
                    props.actions.setSelectedZone(zones.find(x => x.id === metaData.UsedZones[0].ZoneId).name)
                    history.push('/order/' + props.productionOrder.id + '/' + props.productionOrder.orderLineId)

                }).catch((error) => { toast.error(error, { position: "top-center" }) })
            }
            else {
                history.push('/order/' + props.productionOrder.id + '/' + props.productionOrder.orderLineId)
            }
        }
        else {
            history.push('/order/' + props.productionOrder.id + '/' + props.productionOrder.orderLineId)
        }
    }

    let showElapsed = props.productionOrder.productionOrderStatus === state.PAUSED || props.productionOrder.productionOrderStatus === state.RUNNING

    return <div className={classes.orderState}>
        <div className={classes.stateContainer}>
            <div className={classes.icon}>{stateIcon}</div>
            <div className={classes.stateElapsed}>
                <div className={classes.state} style={{ paddingTop: showElapsed ? "0px" : "3px" }}>{t(props.productionOrder.productionOrderStatus)}</div>
                {showElapsed ?
                    <div className={classes.elapsed}><Timer startTime={props.productionOrder.startedOn} {...props}></Timer></div>
                    : <React.Fragment></React.Fragment>
                }
            </div>
        </div>
        <button className={classes.editButton} onClick={() => navigateToOrderDetail()}>
            <div className={classes.editButtonContent}>
                <div className={classes.svg}><svg xmlns="http://www.w3.org/2000/svg" width="17.769" height="17.821" viewBox="0 0 17.769 17.821"><defs></defs><path className="a" fill="#FFFFFF" fillRule="evenodd" d="M17.208,5.978,6.49,16.9a2.042,2.042,0,0,1-1.267.6l-3.381.316A1.662,1.662,0,0,1,0,16.1L.178,12.79a1.947,1.947,0,0,1,.558-1.261L11.455.608A2.055,2.055,0,0,1,14.309.546l2.838,2.649A1.934,1.934,0,0,1,17.208,5.978Zm-15.5,6.459a.649.649,0,0,0-.186.42l-.175,3.308a.332.332,0,0,0,.368.343L5.1,16.191a.681.681,0,0,0,.422-.2l7.629-7.773L9.373,4.626Zm8.6-8.759L14.078,7.27l2.158-2.2a.645.645,0,0,0-.02-.928L13.378,1.494a.685.685,0,0,0-.951.021Z" /></svg></div>
                <div className={classes.editWord}>{t('Edit')}</div>
            </div>
        </button>
        {props.user.isAdministrator && canSwitchRawMaterial &&
            <button className={classes.replaceButton} onClick={() => props.openSwitchRawMaterialDialog(props.productionOrder.orderLineId, props.productionOrder.reference, props.productionOrder.defaultSilo)}>
                <div className={classes.editButtonContent}>
                    <div className={classes.svg}><svg fill="#FFFFFF" xmlns="http://www.w3.org/2000/svg" width="17.769" height="17.821" viewBox="0 0 52 52" enableBackground="new 0 0 52 52" xmlSpace="preserve"><path d="M20,37.5c0-0.8-0.7-1.5-1.5-1.5h-15C2.7,36,2,36.7,2,37.5v11C2,49.3,2.7,50,3.5,50h15c0.8,0,1.5-0.7,1.5-1.5 V37.5z" /><path d="M8.1,22H3.2c-1,0-1.5,0.9-0.9,1.4l8,8.3c0.4,0.3,1,0.3,1.4,0l8-8.3c0.6-0.6,0.1-1.4-0.9-1.4h-4.7 c0-5,4.9-10,9.9-10V6C15,6,8.1,13,8.1,22z" /><path d="M41.8,20.3c-0.4-0.3-1-0.3-1.4,0l-8,8.3c-0.6,0.6-0.1,1.4,0.9,1.4h4.8c0,6-4.1,10-10.1,10v6 c9,0,16.1-7,16.1-16H49c1,0,1.5-0.9,0.9-1.4L41.8,20.3z" /><path d="M50,3.5C50,2.7,49.3,2,48.5,2h-15C32.7,2,32,2.7,32,3.5v11c0,0.8,0.7,1.5,1.5,1.5h15c0.8,0,1.5-0.7,1.5-1.5 V3.5z" /></svg></div>
                    <div className={classes.editWord}>{t('Grondstof')}</div>
                </div>
            </button>
        }
    </div>
}

const useStyles = makeStyles({
    orderState: {
        marginTop: "30px",
        marginBottom: "30px",
        marginLeft: "10px",
        float: "left",
        width: "100%",
        maxWidth: "fit-content",
        boxSizing: "border-box",
        display: 'flex',
        flexDirection: 'column',
        overflow: "hidden",
    },
    stateContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: "fit-content",
        paddingLeft: "10px",
    },
    editButton: {
        backgroundColor: FlagstoneTheme.palette.primary.main,
        display: "block",
        padding: "12px",
        cursor: "pointer",
        marginTop: "10px",
        marginLeft: "10px",
        "&:hover": {
            background: FlagstoneTheme.palette.primary.main
        },
        border: "none",
        outline: "none",
        borderRadius: "5px",
        textAlign: "center"
    },
    replaceButton: {
        backgroundColor: 'orange',
        display: "block",
        padding: "12px",
        cursor: "pointer",
        marginTop: "10px",
        marginLeft: "10px",
        "&:hover": {
            background: 'orange'
        },
        border: "none",
        outline: "none",
        borderRadius: "5px",
        textAlign: "center"
    },
    editButtonContent: {
        width: "fit-content",
        marginRight: "auto",
        marginLeft: "auto"
    },
    editWord: {
        float: "left",
        color: "#FFFFFF",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textTransform: "uppercase"

    },
    svg: {
        float: "left",
        marginRight: "5px",
    },
    play: {
        color: "#5CC958",
        height: "40px",
        width: "40px"
    },
    stop: {
        height: "20px",
        width: "20px",
        backgroundColor: "#D84949",
        borderRadius: "3px",
        margin: "10px",
        marginTop: "8px"
    },
    pause: {
        height: "35px",
        width: "35px",
        color: "#F59127",
        marginLeft: "5px"
    },
    cancel: {
        margin: "10px",
        marginTop: "8px",
        marginLeft: "12px"
    },
    planned: {
        paddingTop: "5px",
        marginRight: "10px",
        marginLeft: "15px"
    },
    done: {
        marginRight: "10px",
        paddingTop: "10px",
        marginLeft: "5px"

    },
    icon: {
        float: "left"
    },
    state: {
        textTransform: "uppercase",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        display: "block"
    },
    stateElapsed: {
        float: "left",
        marginLeft: "5px",
        marginTop: "5px"
    },
    elapsed: {
        fontSize: "10px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#8D8D8D",
        display: "block"
    },

});